
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -1 34 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.955 0c-.005 0-.01.006-.021.006a.639.639 0 00-.221.04c-.005 0-.005.007-.01.007l-.033.02a.626.626 0 00-.156.103c-.016.015-.033.032-.05.053a.548.548 0 00-.089.134l-.031.063a.537.537 0 00-.047.224v9.4a.63.63 0 00.18.442l.431.457H4.83a.783.783 0 00-.789.78c0 .43.352.779.79.779h5.546l1.297 1.373a.67.67 0 00.478.207c.032 0 .059-.01.09-.016.027.005.048.016.069.016H20.957c.156.646.48 1.238.965 1.715a3.597 3.597 0 002.553 1.052h.011a3.602 3.602 0 002.557-1.07c.473-.478.794-1.06.945-1.697h4.848c.363 0 .658-.29.658-.649V4.033c.005-.01 0-.017 0-.027 0-.047-.015-.088-.025-.135-.01-.036-.016-.078-.031-.11-.016-.036-.044-.062-.065-.093-.026-.036-.052-.076-.084-.108-.005-.005-.01-.016-.016-.021L29.217.156A.694.694 0 0028.779 0H8.955zm1.512 1.299h18.07l2.502 2.084H12.443l-1.977-2.084zm-.854.998l2.045 2.162v7.494l-.59-.625a.83.83 0 00-.238-.248L9.613 9.795V2.297zm3.362 2.385h19.209v8.097H28.06a3.627 3.627 0 00-3.59-3.166h-.01a3.58 3.58 0 00-2.555 1.07 3.598 3.598 0 00-1.021 2.096h-7.91V4.682zm11.486 6.19h.01a2.371 2.371 0 012.21 3.216h.014a2.343 2.343 0 01-2.203 1.518h-.008a2.364 2.364 0 01-2.21-1.518h-.015a2.339 2.339 0 01-.113-1.309c.09-.454.31-.874.645-1.209a2.35 2.35 0 011.67-.699zM2.228 10.944H1.29a.784.784 0 00-.79.78c0 .43.353.78.79.78h.938c.437 0 .79-.35.79-.78a.784.784 0 00-.79-.78z"}}),_c('path',{attrs:{"d":"M24.475 11.671h-.004c-.409 0-.795.163-1.085.452s-.448.677-.448 1.085c.004.844.69 1.529 1.533 1.529h.004c.408 0 .795-.163 1.085-.453s.448-.676.448-1.084a1.53 1.53 0 00-1.533-1.529zm.004 2.407a.88.88 0 01-.878-.874.88.88 0 01.874-.879h.004c.233 0 .453.093.615.255a.875.875 0 01-.615 1.498z"}})])
          )
        }
      }
    